import { Sidebar, SidebarInset, SidebarProvider, SidebarRail } from '@myosh/odin-components';
import type { ReactNode } from 'react';
import { AppHeader } from '@/components/layout/app-header';

interface AppLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
}

export const AppLayout = ({ sidebar, children }: AppLayoutProps) => (
  <SidebarProvider storageKey="scheduler:filters">
    <Sidebar>
      {sidebar}
      <SidebarRail />
    </Sidebar>
    <SidebarInset className="min-w-0">
      <AppHeader />
      {children}
    </SidebarInset>
  </SidebarProvider>
);
